// localStorage for per-browser conveniences (panel sizes, remembered
// modes). It is missing during the server render and throws when the
// browser blocks site data (private modes, disabled storage) or is full,
// so these helpers treat every such case as "nothing stored" instead of
// letting it break the page.

/** The stored value, or null when there is none or storage is unavailable. */
export function readStorage(key: string): string | null {
    try {
        if (typeof window === "undefined") return null;
        return localStorage.getItem(key);
    } catch {
        return null;
    }
}

/** Stores a value; when storage is unavailable it is simply not kept. */
export function writeStorage(key: string, value: string): void {
    try {
        localStorage.setItem(key, value);
    } catch {
        // Not remembered for the next visit; the current one is unaffected.
    }
}

/** Forgets a value; does nothing when storage is unavailable. */
export function removeStorage(key: string): void {
    try {
        localStorage.removeItem(key);
    } catch {
        // Nothing to forget.
    }
}
